var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SearchRounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.0833 16.3336H17.1617L16.835 16.0186C18.235 14.3852 18.9583 12.1569 18.5617 9.78858C18.0133 6.54524 15.3067 3.95524 12.04 3.55857C7.105 2.95191 2.95166 7.10524 3.55833 12.0402C3.955 15.3069 6.545 18.0136 9.78833 18.5619C12.1567 18.9586 14.385 18.2352 16.0183 16.8352L16.3333 17.1619V18.0836L21.2917 23.0419C21.77 23.5202 22.5517 23.5202 23.03 23.0419C23.5083 22.5636 23.5083 21.7819 23.03 21.3036L18.0833 16.3336ZM11.0833 16.3336C8.17833 16.3336 5.83333 13.9886 5.83333 11.0836C5.83333 8.17858 8.17833 5.83357 11.0833 5.83357C13.9883 5.83357 16.3333 8.17858 16.3333 11.0836C16.3333 13.9886 13.9883 16.3336 11.0833 16.3336Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3bab4d8c88a709d99f475def1713adee.svg";
export { ForwardRef as ReactComponent };